// /src/components/groups/GroupClosingBanner.jsx
// The notice a closing group shows (Roadmap #103; docs/briefs/2026-10-16-group-being-closed.md,
// rulings 1, 3, 4; addendum 1 ruling 5). A thin caller of NoticeStrip, the one non-modal notice
// surface — no markup of its own.
//
// Presentational: state comes in as props from useGroupClosing in the mounting page. Two wordings:
//   - variant 'group' (group page): says chat stays open and new posts are closed;
//   - variant 'admin' (admin page, edit form, owner card): the closing date only.
// The owner (canUndo) also gets an "Undo closure" action. A group closing without a date (none
// today; possible after account closure) says "This group is closing." rather than invent one.

import React from 'react';
import NoticeStrip from '../core/NoticeStrip';
import { useTranslation } from '../../i18n/useTranslation';

const GroupClosingBanner = ({ closing, closesOn, variant = 'group', canUndo = false, undoing = false, undoFailed = false, onUndo }) => {
  const { formattingLocale } = useTranslation('groups');

  if (!closing) return null;

  if (undoFailed) {
    return <NoticeStrip namespace="groups" tone="error" messageKey="closing_undo_failed"
      action={canUndo ? { labelKey: 'closing_undo_button', onClick: onUndo, disabled: undoing } : undefined} />;
  }

  const date = closesOn ? new Date(closesOn).toLocaleDateString(formattingLocale) : null;
  let messageKey;
  if (!date) messageKey = 'closing_notice_undated';
  else if (variant === 'group') messageKey = 'closing_notice_chat_open';
  else messageKey = 'closing_notice';

  return (
    <NoticeStrip
      namespace="groups"
      tone="warning"
      messageKey={messageKey}
      messageParams={date ? { date } : undefined}
      action={canUndo ? { labelKey: 'closing_undo_button', onClick: onUndo, disabled: undoing } : undefined}
    />
  );
};

export default GroupClosingBanner;
